/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://6dgksmjeibgqzesmp4qrj4w5o4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-t6mwdfprb5cyzkdy5scbbsp5xi",
    "aws_cognito_identity_pool_id": "us-east-1:7e49e6eb-8045-4e47-923e-17832c05f280",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_2dIJNFG5R",
    "aws_user_pools_web_client_id": "7822vfn65sipi7qkn4deqpd27k",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "myappd8b2b7a7f89042888c6de8a4b96813cf193339-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
